
export const inputName = {
  password: 'password',
  confirm_password: 'confirm_password',
};
